import { gridSize } from '@atlaskit/theme/constants';
export var surveyInnerWidth = gridSize() * 55; // 440
export var surveyOffset = gridSize() * 6; // 48